import React from 'react';
import { IIconProps } from './utils';

export const Link = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M3.88233 8.45749L3.4248 8.91501C2.41406 9.92576 2.41406 11.5645 3.4248 12.5752C4.43555 13.586 6.07428 13.586 7.08503 12.5752L8.91514 10.7451C9.92588 9.73438 9.92588 8.09565 8.91514 7.0849M12.1178 7.54243L12.5754 7.0849C13.5861 6.07416 13.5861 4.43542 12.5754 3.42468C11.5646 2.41394 9.92588 2.41394 8.91514 3.42468L7.08503 5.25479C6.07428 6.26554 6.07428 7.90427 7.08503 8.91501"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="1.33333"
    />
  </svg>
);
